import {
  PackageOpen,
  ShoppingBag,
  UserPlus,
  Users,
  type LucideIcon,
  type LucideProps,
} from "lucide-react";

export const ProfileStatsIcons = {
  listings: PackageOpen,
  sales: ShoppingBag,
  followers: Users,
  following: UserPlus,
} as const satisfies Record<string, LucideIcon>;

export type ProfileStatIconKey = keyof typeof ProfileStatsIcons;

export function ProfileStatIcon({
  name,
  className,
  ...props
}: { name: ProfileStatIconKey; className?: string } & LucideProps) {
  const Icon = ProfileStatsIcons[name];
  return <Icon className={className} {...props} />;
}
